module.exports = __webpack_public_path__ + "img/file-copy.89e99caf.svg";